import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const UserPrimaryNumberCallClickEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.USER_PRIMARY_NUMBER_CALL_CLICK_EVENT,
    properties,
  );

export const UserAlternativeNumberCallClickEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.USER_ALTERNATIVE_NUMBER_CALL_CLICK_EVENT,
    properties,
  );

export const MerchantCallClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.MERCHANT_CALL_CLICK_EVENT, properties);

export const ValetCallClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.VALET_CALL_CLICK_EVENT, properties);

export const AssignedRiderCallClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.ASSIGNED_RIDER_CALL_CLICK_EVENT, properties);

export const OFSEUserCallClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.OFSE_USER_CALL_CLICK_EVENT, properties);
